import { render, staticRenderFns } from "./XDevPage.vue?vue&type=template&id=0b37d36a&scoped=true"
import script from "./XDevPage.vue?vue&type=script&lang=js"
export * from "./XDevPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b37d36a",
  null
  
)

export default component.exports